/*
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2023-08-02 14:09:19
 * @LastEditors: w9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-11-09 11:51:02
 * @FilePath: \community-backende:\sns-user-frontend\src\lang\en-GB\page\template.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default {
  powerCommunity: 'Power of Community',
  pocTitle: 'Power of OnePlus Community 2023',
  pocDescribe: `In keeping with the Never Settle ethos, your support, feedback, and ideas all contribute to superior future tech products.`,
  tabTester: 'Tech Trials',
  tabIdeas: 'Tech IDEAs',
  productIntro: 'Get the chance to try out exciting new products from our POC collabs.',
  ideasIntro: 'Discover user IDEAs, submit your own, and win prizes. Spark creativity.',
  pubPlaceholder: 'Describe your ideas here',

  publish: 'Submit tech IDEAs',
  logToPublish: 'Log in to submit tech IDEAs',

  allIdeas: 'All IDEAs',
  topIdeas: 'Top IDEAs',
  myIdeas: 'My IDEAs',

  comming: 'Coming soon',
  toBeAnnounced: 'Winner to be announced',
  supporter: 'Supporter | Supporter | Supporters',
  logToSupport: 'Log in to support',
  winnerList: 'Winner List',
  discuss: 'Discuss',
  userReview: 'User reviews',
  userIdeas: 'User IDEAs',
  userIDEAs: 'User IDEAs',
  supported: 'Support | Supported | Supported',
  left: 'left',
  story: 'Brand Story',
  update: 'Update',
  discuss: 'Discuss',
  productReviews: 'Product Review',
  
  days: 'day | day | days',
  hours: 'hour | hour | hours',
  minutes: 'minute | minute | minutes',
  tester: 'Tech Trials',
  ideas: 'Tech IDEAs',
  target: 'Target | Target | Targets',
  faq: 'FAQ',
  viewMore: 'View More',
  mightLike: 'You may also like',
  POC: 'POC',
  collapse: 'Collapse',
  seeDetail: 'See Details',
  ideasGuide: `Do you have a vision for a creative new product? Spark your IDEAs and shape the future of tech with us. If selected, your Tech IDEA may be implemented in partnership with our POC Collabs. You'll also be the first to experience the product - for free.`,
  topIdeasTip: `We're still collecting IDEAs. Share your suggestions for a chance to win prizes!`,
  howItWord: 'How it works',
  rulesDescrp: `Nurture and capture innovative ideas, concepts based on customer desires`,
  testerRule1: 'Support your project',
  testerRule2: 'Reach the target',
  testerRule3: 'Winner announcement',
  testerRule4: 'Test and share',

  ideasRule1: 'Share your Tech IDEAs related to the category',
  ideasRule2: 'Review and discuss',
  ideasRule3: 'Top IDEAs will be selected each month',
  ideasRule4: 'Successful IDEAs may be implemented with OnePlus and POC Collabs, with free user experiences',

  
  winnerAnnounced: 'Winner announced',
  endedIn: 'Ends in',
  
  home: 'Home',
  detail: 'Details',
  
  loginSupport: 'Log in to support',
  referralFriend: 'Referral friend',
  notify: 'Notify me',
  subscribed:'Subscribed',
  startAt: 'Start at',
  notifySuccess: 'Thank you for subscribing. You will receive a notification when the product goes live.',
  willNotice: 'Will Notice when Online',
}